module.exports = __webpack_public_path__ + "static/media/memory-wheel.c9c18bba.png";